"use client"

import type { ComponentPropsWithRef, ReactNode } from 'react'
import { Button, Tooltip } from '@heroui/react'

type ButtonProps = ComponentPropsWithRef<typeof Button>

interface IconButtonProps extends Omit<ButtonProps, 'aria-label' | 'children' | 'isIconOnly'> {
  children: ReactNode
  label: string
  tooltip?: ReactNode
}

export function IconButton({ children, label, tooltip, ...buttonProps }: IconButtonProps): React.ReactElement {
  return (
    <Tooltip>
      <Tooltip.Trigger>
        <Button isIconOnly aria-label={label} {...buttonProps}>
          {children}
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content>{tooltip ?? label}</Tooltip.Content>
    </Tooltip>
  )
}
